import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic-select"
export default class extends Controller {
  static values = { params: { type: Object, default: {} } }
  static targets = ["trigger"]

  request() {
    let searchParams = new URLSearchParams()

    for (const [param, elementId] of Object.entries(this.paramsValue)) {
      let element = document.getElementById(elementId)
      if (element) {
      searchParams.append(param, element.value)
      }
    }

    this.triggerTarget.href = this.triggerTarget.href.split("?")[0]
    this.triggerTarget.href = `${this.triggerTarget.href}?${searchParams}`
    this.triggerTarget.click()
  }
}
